export const NBN_SOURCE = "project-layers";
export const NBN_SOURCE_LAYER = "input_layers/cabling/sl";
export const NBN_STYLE_ID = "nbn-draw-point-sl";
export const NBN_SOURCE_LAYER_FILTER = ["==", ["get", "project_code"], "N2P-MOD"];
